import PropTypes from 'prop-types';
import IconSvg from 'Components/IconSvg';
const iconMap = {
  error: {
    icon: 'error',
    className: 'icon--error',
  },
  success: {
    icon: 'checkmark',
    className: 'icon--success',
  },
};

const Notification = ({ icon, message }) => {
  const iconComponent = iconMap[icon];
  return (
    <>
      <div className="icon-heading">
        {iconComponent && (
          <IconSvg
            type={iconComponent.icon}
            className={iconComponent.className}
          />
        )}
      </div>
      <h1 className="page-heading">{message}</h1>
    </>
  );
};

Notification.propTypes = {
  icon: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
};

export default Notification;
